
import { useState, useRef, Fragment } from "react";
import Config from "../../Config";


import PlTitle from "../../elements/PlTitle";

import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputComboRok from "../../helpers/InputComboRok";
import InputComboMiesiac from "../../helpers/InputComboMiesiac";


import FreeEditE from "./FreeEditE";

import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import { json } from "react-router-dom";
import AppContext from "../../AppContext";


function Free(props)
{

    const tabRef = useRef(0);
    const tab2Ref = useRef(0);

    
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({
        p_imie_nazwisko: props.mainView.readFilter('p_imie_nazwisko',''),       
        rok: (new Date()).getFullYear() ,
        miesiac: (new Date() ).getMonth()+1,
        dzien: (new Date() ).getDay(),
        limit: 50,
        page: 1,
        pages: 1,
        show: !props.mainView.isMobile(), 
    });
    const [tab, setTab] = useState(null);



    var dt = new Date();
    const [showDay, setShowDay] = useState({
        from: dt.getDate() - 3,
        to: dt.getDate() + 3,
    });
    const [strToDay, setStrToDate] = useState( dt.toISOString().split`T`[0]  ); 


    const [slPowody, setSlPowody] = useState(null);



    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_employessModule,free', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);   
                        setSlPowody(res.result[0].powody);         
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

   

    const valChangeListener = (filedName, val, correct, msg) => {

       // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }

        props.mainView.writeFilter(filedName, val);
    }


    const goNextNew = () => {
          
        setTab(null);    
    }

    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }

    const filterClear = () => {
        setFilterParam({
            p_imie_nazwisko: '',        
            rok: (new Date()).getFullYear() ,
            miesiac: (new Date() ).getMonth()+1,      
            limit: 50,
            page: 1,
            show:true,
        });
        setTab(null);

    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }


    /*
    if(slPowody == null)
        {
            setSlPowody([]);
            getSl();
        }
*/

    if(tab == null)
        {
            setTab([]);
            getTab();
         
    
            return <div>
                ...
            </div>
        }
       

       
    if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);           
        }

    var css='';    

        

    return (
        <div className="view_content">
              

                 {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
                } 

                {
                    filterParam.show == true  &&
                    <div className="  goright link_color" onClick={filterView}>
                        ukryj filtry
                    </div>
                } 


                {
                    filterParam.show == true  &&
                    <div className="table_filter">

                        

                        <div className="filter_controll">   
                            <label>Rok: </label>                             
                            <InputComboRok   userData={props.userData}  mainView={props.mainView}  value={filterParam.rok}   valChange={valChangeListener} goNext={goNextNew} name="rok" placeholder={": "}  noempty="1"   />
                        </div> 

                      
                        <div className="filter_btn">
                            
                            <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                        </div>
                    </div>

                } 



           


            <div className="bg_center">
                
            
                
                <div ref={tabRef} className="">
                        <br/>
                        <div className="calColor">Urlopy {filterParam.rok  }</div> 
                        <br/>
                        <div className="filter_btn ">
                        
                        {
                            tab['0'] !== undefined  &&
                            <FreeEditE mainView={props.mainView} userData={props.userData} row={tab[0]}  className={"gocenter nbx_squre txtcloud " + css}  onSucess={getTab} powody={slPowody} title={ tab[0].nazwisko + " " + tab[0].imie } ></FreeEditE>    
                        }
                        
                        
                        </div>
                        <br/>
                        <table className="table" ref={tab2Ref} >
                        <thead>
                            <tr className="header">
                                <td className="td_left">LP</td>                                                 
                                <td>Data</td>    
                                <td>Rodzaj urlopu</td>    
                                <td className="td_right">Powód</td>    
                            </tr>
                            

                            
                        </thead>
                        <tbody>

                        {
                            tab.map( (row, ix) => {
    

                                return (
                                    row.urlopy.map( (urlop, id) => {
                                        return (
                                            <tr>
                                                <td >{id+1}</td>
                                                <td className="gocenter">{urlop.t0_dzien}</td>
                                                <td >{urlop.t1_nazwa}</td>
                                                <td >{urlop.t0_powod}</td>
                                            </tr>
                                        )} )
                                    )
                            } )
                        }  

                        </tbody>
                    </table>
                </div>

                <br/>
                    <div className="calColor">Urlopy - podsumowanie  {filterParam.rok}</div>   
                <br/>        

                <table className="table">
                        <thead>
                            <tr className="header"> 
                                
                                <td className="td_left">Rodzaj urlopu</td>
                                <td className="td_right">Ilość</td>
                            </tr>
                        </thead>
                           {
                                tab.map( (row, inx) => {

                                       

                                       if(row.sum == undefined) return null;

                                       return <Fragment>
                                        
                                           {
                                             row.sum != undefined &&
                                             <Fragment>
                                                        {
                                                            row.sum.map( ( n, nInx )  => {
                                                                return <tr className="row2">
                                                                        
                                                                            <td>{n.nazwa}</td>
                                                                            <td className="gocenter">{n.razem}</td>
                                                                </tr>
                                                            } )
                                                        }
                                             </Fragment>                                                                                             
                                           }
                                        
                                       </Fragment>                                                                               

                                } )
                           }
                      </table>         

            </div>


        </div>
    )
}


export default Free;